import {autoserializeAs, inheritSerialization} from 'cerialize';
import { EmailListTransformer } from '../helpers/enum/email-list-transformer';
import { EmailList } from './email-list';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class EmailPreference extends ModelBase {
  public static readonly type = 'EmailPreference';
  public readonly type = EmailPreference.type;

  @autoserializeAs(EmailListTransformer, 'email_list')
  public emailList: EmailList;

  @autoserializeAs('subscribed')
  public subscribed: boolean;
}
